import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import logo from "../../assets/assets/images/Inaipi_Logo-1.2.png";
import { ClockUser, Dresser, PhoneTransfer, UserCircleGear } from "@phosphor-icons/react";
import { HiOutlinePhoneMissedCall } from "react-icons/hi";
import { Badge } from "@mui/material";
import { TbReportSearch } from "react-icons/tb";
import { connect } from "react-redux";
import { MdLogout } from "react-icons/md";

import {
  clearnotify,
  setsidebarVal,
  setShowNotification,
  setShowUserProfile,
  setshowExternalChat,
  setExternalChatData,
  setExternalChatActive,
  setshowphonedialer,
} from "../../redux/actions/actions";
import { BaseUrl } from "../../container/BaseUrl/BaseUrl";
import axios from "axios";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));

const mapStateToProps = (state) => {
  return {
    notification: state.notification.notification,
    sidebarVal: state.contactListData.sidebarVal,
  };
};

const Sidebar = (props) => {
  let agentRole = JSON.parse(localStorage.getItem("tokenAgent"));
  let permission = JSON.parse(localStorage.getItem("permission"));
  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
    },
  }));

  const [AbandonedCount, setAbandonedCount] = useState(0);
  const [AbandonedCountSupervisoragent, setAbandonedCountSupervisoragent] = useState(0);
  setInterval(async () => {
      permission.map(async (module) => {
        if (module.moduleId === "VOICE") {
          const crmScreen = module.screen.find(
            (item) => item.screenId === "MISSEDCALL" && item.read && item.write
          );
  
          if (crmScreen) {
            if (agentRole.role == "Supervisor") {
              await axios
                .post(
                  BaseUrl + "/contact/missedcallcount",
                  {
                    agent_id: agentRole.agent_id,
                    role: "Supervisor",
                  },
                  {
                    headers: {
                      Authorization:
                        "Bearer " + localStorage.getItem("access_token"),
                      "Content-Type": "application/json",
                      tenantId: localStorage.getItem("TenantId"),
                    },
                  }
                )
                .then((res) => {
                  if (res.data.status) {
                    setAbandonedCount(res.data.count);
                  } else {
                    setAbandonedCount(0);
                  }
                })
                .catch((err) => {});
            }else{
              await axios
              .post(
                BaseUrl + "/contact/missedcallcount",
                {
                  agent_id: agentRole.agent_id,
                  role: "Agent",
                },
                {
                  headers: {
                    Authorization:
                      "Bearer " + localStorage.getItem("access_token"),
                    "Content-Type": "application/json",
                    tenantId: localStorage.getItem("TenantId"),
                  },
                }
              )
              .then((res) => {
                if (res.data.status) {
                  setAbandonedCount(res.data.count);
                } else {
                  setAbandonedCount(0);
                }
              })
              .catch((err) => {});
            }

             if (agentRole.supervisoragent==true) {
              await axios
                .post(
                  BaseUrl + "/contact/missedcallcount",
                  {
                    agent_id: agentRole.agent_id,
                    role: "Agent",
                  },
                  {
                    headers: {
                      Authorization:
                        "Bearer " + localStorage.getItem("access_token"),
                      "Content-Type": "application/json",
                      tenantId: localStorage.getItem("TenantId"),
                    },
                  }
                )
                .then((res) => {
                  if (res.data.status) {
                    setAbandonedCountSupervisoragent(res.data.count);
                  } else {
                    setAbandonedCountSupervisoragent(0);
                  }
                })
                .catch((err) => {});
            }
          }
        }
      });
    
  }, 30000);


  
  return (
    <>
      {agentRole.role == "Supervisor" ? (
        <aside
          className="aside_left animate__animated animate__fadeInLeft"
          style={{ zIndex: 1 }}
        >
          <div className="logo-aside">
            <Link
              id="logo-aside"
              to={"/main/Dashboard"}
              onClick={() => {
                props.setsidebarVal("Dashboard");
                props.setShowNotification(false);
                props.setShowUserProfile(false);
                props.setshowExternalChat(false);
                props.clearnotify();
                props.setshowphonedialer(false);
              }}
            >
              <img src={logo} alt="" style={{ width: "40px" }} />
            </Link>
          </div>
          <nav
            className="navbar navbar-nav side-nav  pt-0 w-100"
            style={{ paddingRight: "0px" }}
          >
            <ul
              className="navbar-nav w-100 CONTACT-LIST-AREA"
              style={{
                marginLeft: "0px",
                overflowY: "scroll",
                height: "85vh",
              }}
            >
              {permission.find(
                (element) => element.moduleName === "Dashboard"
              ) ? (
                <>
                  <Link to={"/main/Dashboard"}>
                    <BootstrapTooltip
                      title={"Dashboard"}
                      arrow
                      placement="right"
                    >
                      <li
                        className={
                          props.sidebarVal == "Dashboard"
                            ? "nav-item sideBaractive"
                            : "nav-item"
                        }
                        id="dashboard_chat_supervisor"
                        onClick={() => {
                          props.setsidebarVal("Dashboard");
                          props.setShowNotification(false);
                          props.setShowUserProfile(false);
                          props.setshowExternalChat(false);
                          props.setExternalChatData("");
                          props.setshowphonedialer(false);
                          document.title = "Inaipi Digital • Dashboard";
                        }}
                      >
                        <i
                          className="material-symbols-outlined"
                          style={{ color: "#ffff", fontSize: "19px" }}
                        >
                          grid_view
                        </i>
                      </li>
                    </BootstrapTooltip>
                  </Link>
                </>
              ) : null}
              {permission.find((element) => element.moduleName === "Chat") ? (
                <>
                  <BootstrapTooltip
                    title={"Interaction"}
                    arrow
                    placement="right"
                  >
                    <Link to={"/main/Chat"}>
                      <li
                        className={
                          props.sidebarVal == "Chat"
                            ? "nav-item sideBaractive"
                            : "nav-item"
                        }
                        id="chat_chat_supervisor"
                        onClick={() => {
                          props.setsidebarVal("Chat");
                          props.setShowNotification(false);
                          props.setShowUserProfile(false);
                          props.setshowExternalChat(false);
                          props.setExternalChatData("");
                          document.title = "Inaipi Digital • Chat";
                        }}
                      >
                        {/* <Badge
                          color="warning"
                          badgeContent={
                            props.notification ? props.notification.length : 0
                          }
                          sx={{ top: "3px" }}
                        /> */}

                        <StyledBadge
                          badgeContent={
                            props.notification ? props.notification.length : 0
                          }
                          color="error"
                          invisible={
                            props.notification.length == 0 ? true : false
                          }
                        >
                          <i
                            className="material-symbols-outlined"
                            style={{ color: "#ffff", fontSize: "19px" }}
                          >
                            sms
                          </i>
                        </StyledBadge>
                      </li>
                    </Link>
                  </BootstrapTooltip>
                </>
              ) : null}
              {permission.find((element) => element.moduleName === "Report") ? (
                <>
                  <BootstrapTooltip
                    title={"Session Report"}
                    arrow
                    placement="right"
                  >
                    <Link to={"/main/SessioReports"}>
                      <li
                        className={
                          props.sidebarVal == "Sessionreport"
                            ? "nav-item sideBaractive"
                            : "nav-item"
                        }
                        id="sessionreports_chat_supervisor"
                        onClick={() => {
                          props.setsidebarVal("Sessionreport");
                          props.setShowNotification(false);
                          props.setShowUserProfile(false);
                          props.setshowExternalChat(false);
                          props.setExternalChatData("");
                          props.setshowphonedialer(false);
                          document.title = "Inaipi Digital • Reports";
                        }}
                      >
                        <i
                          className="material-symbols-outlined"
                          style={{ color: "#ffff", fontSize: "19px" }}
                        >
                          leaderboard
                        </i>
                      </li>
                    </Link>
                  </BootstrapTooltip>
                </>
              ) : null}
              {permission.find((element) => element.moduleName === "Report") ? (
                <>
                  <BootstrapTooltip
                    title={"Agent Report"}
                    arrow
                    placement="right"
                  >
                    <Link to={"/main/AgentReports"}>
                      <li
                        className={
                          props.sidebarVal == "Agentreport"
                            ? "nav-item sideBaractive"
                            : "nav-item"
                        }
                        id="agentreports_chat_supervisor"
                        onClick={() => {
                          props.setsidebarVal("Agentreport");
                          props.setShowNotification(false);
                          props.setShowUserProfile(false);
                          props.setshowExternalChat(false);
                          props.setExternalChatData("");
                          props.setshowphonedialer(false);
                          document.title = "Inaipi Digital • Reports";
                        }}
                      >
                        <i
                          className="material-symbols-outlined"
                          style={{ color: "#ffff", fontSize: "19px" }}
                        >
                          table_chart
                        </i>
                      </li>
                    </Link>
                  </BootstrapTooltip>
                </>
              ) : null}
              {/* CMS */}
              {permission.map((module) => {
                if (module.moduleName === "Crm") {
                  const crmScreen = module.screen.find(
                    (item) =>
                      item.screenId === "CONTACT" && item.read && item.write
                  );

                  if (crmScreen) {
                    return (
                      <BootstrapTooltip title={"CMS"} arrow placement="right">
                        <Link to={"/main/CMS"}>
                          <li
                            className={
                              props.sidebarVal == "CMS"
                                ? "nav-item sideBaractive"
                                : "nav-item"
                            }
                            id="sessionreports_chat_agent"
                            onClick={() => {
                              props.setsidebarVal("CMS");
                              props.setShowNotification(false);
                              props.setShowUserProfile(false);
                              props.setshowExternalChat(false);
                              props.setExternalChatData("");
                              props.setExternalChatActive("");
                              props.setshowphonedialer(false);
                              document.title = "Inaipi Digital • Contact";
                            }}
                          >
                            <i
                              className="material-symbols-outlined"
                              style={{ color: "#ffff", fontSize: "19px" }}
                            >
                              backup_table
                            </i>
                          </li>
                        </Link>
                      </BootstrapTooltip>
                    );
                  } else {
                    return <></>;
                  }
                }
              })}
              {permission.find(
                (element) => element.moduleName === "Multimedia"
              ) ? (
                <BootstrapTooltip
                  title={"Multimedia Search"}
                  arrow
                  placement="right"
                >
                  <Link to={"/main/multimediasearch"}>
                    <li
                      className={
                        props.sidebarVal == "Multimedia"
                          ? "nav-item sideBaractive"
                          : "nav-item"
                      }
                      id="multimedia_chat_agent"
                      onClick={() => {
                        props.setsidebarVal("Multimedia");
                        document.title = "Inaipi Digital • Multimedia";
                      }}
                    >
                      <i
                        className="fa-solid fa-magnifying-glass"
                        style={{ color: "#ffff", fontSize: "18x" }}
                      ></i>
                    </li>
                  </Link>
                </BootstrapTooltip>
              ) : null}

              {permission.map((module) => {
                if (module.moduleName === "Crm") {
                  const crmScreen = module.screen.find(
                    (item) =>
                      item.screenId === "CONTACTSALES" &&
                      item.read &&
                      item.write
                  );

                  if (crmScreen) {
                    return (
                      <>
                        <BootstrapTooltip
                          title={"Supervisor-Contact"}
                          arrow
                          placement="right"
                        >
                          <Link to={"/main/supervisorContact"}>
                            <li
                              className={
                                props.sidebarVal == "Contact"
                                  ? "nav-item sideBaractive"
                                  : "nav-item"
                              }
                              id="Contact_chat_supervisor"
                              onClick={() => {
                                props.setsidebarVal("Contact");
                                props.setShowNotification(false);
                                props.setShowUserProfile(false);
                                props.setshowExternalChat(false);
                                props.setExternalChatData("");
                                props.setshowphonedialer(false);
                                document.title =
                                  "Inaipi Digital • Supervisor-Contact";
                              }}
                            >
                              <i
                                className="material-symbols-outlined"
                                style={{ color: "#ffff", fontSize: "19px" }}
                              >
                                perm_contact_calendar
                              </i>
                            </li>
                          </Link>
                        </BootstrapTooltip>
                      </>
                    );
                  } else {
                    return <></>;
                  }
                }
              })}
              {permission.find(
                (element) => element.moduleName === "Calender"
              ) ? (
                <BootstrapTooltip title={"Calender"} arrow placement="right">
                  <Link to={"/main/Calenders"}>
                    <li
                      className={
                        props.sidebarVal == "Calender"
                          ? "nav-item sideBaractive"
                          : "nav-item"
                      }
                      id="Calender_chat_supervisor"
                      onClick={() => {
                        props.setsidebarVal("Calender");
                        props.setShowNotification(false);
                        props.setShowUserProfile(false);
                        props.setshowExternalChat(false);
                        props.setExternalChatData("");
                        props.setshowphonedialer(false);
                        document.title = "Inaipi Digital • Calender";
                      }}
                    >
                      <i
                        className="material-symbols-outlined"
                        style={{ color: "#ffff", fontSize: "19px" }}
                      >
                        calendar_month
                      </i>
                    </li>
                  </Link>
                </BootstrapTooltip>
              ) : null}

              {permission.find(
                (element) => element.moduleName === "Calender"
              ) ? (
                <BootstrapTooltip
                  title={"Web-Statistic"}
                  arrow
                  placement="right"
                >
                  <Link to={"/main/statistic"}>
                    <li
                      className={
                        props.sidebarVal == "Statistic"
                          ? "nav-item sideBaractive"
                          : "nav-item"
                      }
                      // className="nav-item"
                      id="Calender_chat_agent"
                      onClick={() => {
                        props.setsidebarVal("Statistic");
                        props.setShowNotification(false);
                        props.setShowUserProfile(false);
                        props.setshowExternalChat(false);
                        props.setExternalChatData("");
                        props.setExternalChatActive("");
                        props.setshowphonedialer(false);
                        document.title = "Inaipi Digital • Web-Statistic";
                      }}
                    >
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#ffff", fontSize: "19px" }}
                      >
                        pie_chart
                      </span>
                    </li>
                  </Link>
                </BootstrapTooltip>
              ) : null}

              <BootstrapTooltip title={"Agent-Status"} arrow placement="right">
                <Link to={"/main/AgentStatus"}>
                  <li
                    className={
                      props.sidebarVal == "AgentStatus"
                        ? "nav-item sideBaractive"
                        : "nav-item"
                    }
                    // className="nav-item"
                    id="Calender_chat_agent"
                    onClick={() => {
                      props.setsidebarVal("AgentStatus");
                      props.setShowNotification(false);
                      props.setShowUserProfile(false);
                      props.setshowExternalChat(false);
                      props.setExternalChatData("");
                      props.setExternalChatActive("");
                      props.setshowphonedialer(false);
                      document.title = "Inaipi Digital • Agent-Status";
                    }}
                  >
                    <span
                      className="material-symbols-outlined"
                      style={{ color: "#ffff", fontSize: "20px" }}
                    >
                      groups
                    </span>
                  </li>
                </Link>
              </BootstrapTooltip>

              {permission.find(
                (element) => element.moduleName === "Calender"
              ) ? (
                <BootstrapTooltip
                  title={"Queued Interaction"}
                  arrow
                  placement="right"
                >
                  <Link to={"/main/Queue-Chat"}>
                    <li
                      className={
                        props.sidebarVal == "QueueChat"
                          ? "nav-item sideBaractive"
                          : "nav-item"
                      }
                      id="powerBi_chat_supervisor"
                      onClick={() => {
                        props.setsidebarVal("QueueChat");
                        props.setShowNotification(false);
                        props.setShowUserProfile(false);
                        props.setshowExternalChat(false);
                        props.setExternalChatData("");
                        props.setshowphonedialer(false);
                      }}
                    >
                      <i
                        class="fa-solid fa-list"
                        style={{ color: "#ffff", fontSize: "17px" }}
                      ></i>
                    </li>
                  </Link>
                </BootstrapTooltip>
              ) : null}

              {/* {permission.find(
                (element) => element.moduleName === "Calender"
              ) ? (
                <BootstrapTooltip title={"Reports"} arrow placement="right">
                  <Link to={"/main/reports"}>
                    <li
                      className={
                        props.sidebarVal == "Reports"
                          ? "nav-item sideBaractive"
                          : "nav-item"
                      }
                      id="reports_chat_supervisor"
                      onClick={() => {
                        props.setsidebarVal("Reports");
                        props.setShowNotification(false);
                        props.setShowUserProfile(false);
                        props.setshowExternalChat(false);
                        props.setExternalChatData("");
                        props.setshowphonedialer(false);
                      }}
                    >
                      <i
                        class="fa-solid fa-chart-gantt"
                        style={{ color: "#ffff", fontSize: "17px" }}
                      ></i>
                    </li>
                  </Link>
                </BootstrapTooltip>
              ) : null} */}
              {permission.map((module) => {
                if (module.moduleId === "VOICE") {
                  const crmScreen = module.screen.find(
                    (item) =>
                      item.screenId === "CAMPAIGN" && item.read && item.write
                  );

                  if (crmScreen) {
                    return (
                      <>
                        <BootstrapTooltip
                          title={"Campaign"}
                          arrow
                          placement="right"
                        >
                          <Link to={"/main/Campaign"}>
                            <li
                              className={
                                props.sidebarVal == "Campaign"
                                  ? "nav-item sideBaractive"
                                  : "nav-item"
                              }
                              id="Agent_supervisor"
                              onClick={() => {
                                props.setsidebarVal("Campaign");
                                props.setShowNotification(false);
                                props.setShowUserProfile(false);
                                props.setshowExternalChat(false);
                                props.setExternalChatData("");
                                props.setshowphonedialer(false);
                              }}
                            >
                              <Dresser size={17} weight="bold" color="#ffff" />
                            </li>
                          </Link>
                        </BootstrapTooltip>
                      </>
                    );
                  } else {
                    return <></>;
                  }
                }
              })}
              {permission.map((module) => {
                if (module.moduleId === "VOICE") {
                  const crmScreen = module.screen.find(
                    (item) =>
                      item.screenId === "MISSEDCALL" && item.read && item.write
                  );

                  if (crmScreen) {
                    return (
                      <>
                        <BootstrapTooltip
                          title={"Manage Abandoned Calls"}
                          arrow
                          placement="right"
                        >
                          <Link to={"/main/MissedCalls"}>
                            <li
                              className={
                                props.sidebarVal == "Missed Calls"
                                  ? "nav-item sideBaractive"
                                  : "nav-item"
                              }
                              id="reports_chat_supervisor"
                              onClick={() => {
                                props.setsidebarVal("Missed Calls");
                                props.setShowNotification(false);
                                props.setShowUserProfile(false);
                                props.setshowExternalChat(false);
                                props.setExternalChatData("");
                                props.setshowphonedialer(false);
                              }}
                            >
                              <StyledBadge
                                badgeContent={
                                  AbandonedCount ? AbandonedCount : 0
                                }
                                color="error"
                                invisible={AbandonedCount == 0 ? true : false}
                              >
                                <HiOutlinePhoneMissedCall
                                  size={17}
                                  weight="bold"
                                  color="#ffff"
                                />
                              </StyledBadge>
                            </li>
                          </Link>
                        </BootstrapTooltip>
                      </>
                    );
                  } else {
                    return <></>;
                  }
                }
              })}


             {/* New 2 report */}

   

            {permission.map((module) => {
                if (module.moduleId === "REPORT") {
                  const crmScreen = module.screen.find(
                    (item) =>
                      item.screenId === "AGENTLOGINREPORT" && item.read && item.write
                  );

                  if (crmScreen) {
                    return (
                      <>
                        <BootstrapTooltip
                          title={"Agent LoginLogout Report"}
                          arrow
                          placement="right"
                        >
                          <Link to={"/main/agentloginlogoutreport"}>
                            <li
                              className={
                                props.sidebarVal == "agentloginlogoutreport"
                                  ? "nav-item sideBaractive"
                                  : "nav-item"
                              }
                              id="reports_chat_supervisor"
                              onClick={() => {
                                props.setsidebarVal("agentloginlogoutreport");
                                props.setShowNotification(false);
                                props.setShowUserProfile(false);
                                props.setshowExternalChat(false);
                                props.setExternalChatData("");
                                props.setshowphonedialer(false);
                              }}
                            >
              
                                <UserCircleGear
                                  size={20}
                                  weight="bold"
                                  color="#ffff"
                                />
                            
                            </li>
                          </Link>
                        </BootstrapTooltip>
                      </>
                    );
                  } else {
                    return <></>;
                  }
                }
              })}



             {permission.map((module) => {
                if (module.moduleId === "REPORT") {
                  const crmScreen = module.screen.find(
                    (item) =>
                      item.screenId === "AGENTSTATUSREPORT" && item.read && item.write
                  );

                  if (crmScreen) {
                    return (
                      <>
                       <BootstrapTooltip
                          title={"Agent Status Report"}
                          arrow
                          placement="right"
                        >
                          <Link to={"/main/agentstatusreport"}>
                            <li
                              className={
                                props.sidebarVal == "agentstatusreport"
                                  ? "nav-item sideBaractive"
                                  : "nav-item"
                              }
                              id="reports_chat_supervisor"
                              onClick={() => {
                                props.setsidebarVal("agentstatusreport");
                                props.setShowNotification(false);
                                props.setShowUserProfile(false);
                                props.setshowExternalChat(false);
                                props.setExternalChatData("");
                                props.setshowphonedialer(false);
                              }}
                            >
 
                                <ClockUser
                                  size={20}
                                  weight="bold"
                                  color="#ffff"
                                />
                             
                            </li>
                          </Link>
                        </BootstrapTooltip>
                      </>
                    );
                  } else {
                    return <></>;
                  }
                }
              })}





               

 {/* New 2 report */}


              {agentRole.role == "Supervisor" && agentRole.supervisoragent ? (
                <BootstrapTooltip
                  title={"Abandoned Call"}
                  arrow
                  placement="right"
                >
                  <Link to={"/main/MakeCalls"}>
                    <li
                      className={
                        props.sidebarVal == "MakeCalls"
                          ? "nav-item sideBaractive"
                          : "nav-item"
                      }
                      id="reports_chat_supervisor"
                      onClick={() => {
                        props.setsidebarVal("MakeCalls");
                        props.setShowNotification(false);
                        props.setShowUserProfile(false);
                        props.setshowExternalChat(false);
                        props.setExternalChatData("");
                        props.setshowphonedialer(false);
                      }}
                    >
                      {/* <PhoneTransfer size="20px" color="white" /> */}

                      <StyledBadge
                      badgeContent={AbandonedCountSupervisoragent ? AbandonedCountSupervisoragent : 0}
                      color="error"
                      invisible={AbandonedCountSupervisoragent == 0 ? true : false}
                    >
                      <PhoneTransfer
                        size={20}
                        weight="bold"
                        color="#ffff"
                      />
                    </StyledBadge>
                    </li>
                  </Link>
                </BootstrapTooltip>
              ) : (
                ""
              )}

              {/* <BootstrapTooltip title={"Reports"} arrow placement="right">
                <Link>
                  <li
                    className={
                      props.sidebarVal == "Reportsss"
                        ? "nav-item sideBaractive"
                        : "nav-item"
                    }
                    id="reports_chat_supervisor"
                    onClick={() => {
                      props.setsidebarVal("Reportsss");
                      props.setShowNotification(false);
                      props.setShowUserProfile(false);
                      props.setshowExternalChat(false);
                      props.setExternalChatData("");
                      props.setshowphonedialer(false);
                      window.open(
                        "http://10.235.150.78/accs_report/call_presentation.php",
                        "_blank"
                      );
                    }}
                  >
                    <TbReportSearch size={17} weight="bold" color="#ffff" />
                  </li>
                </Link>
              </BootstrapTooltip> */}
            </ul>
          </nav>
        </aside>
      ) : (
        <aside
          className="aside_left animate__animated animate__fadeInLeft"
          style={{ zIndex: 1 }}
        >
          <div className="logo-aside">
            <NavLink
              id="logo-aside"
              to={"/main/Dashboard"}
              onClick={() => {
                props.setsidebarVal("Dashboard");
                props.setShowNotification(false);
                props.setShowUserProfile(false);
                props.setshowExternalChat(false);
                props.setExternalChatData("");
                props.setExternalChatActive("");
                props.setshowphonedialer(false);
              }}
            >
              <img src={logo} alt="" style={{ width: "35px" }} />
            </NavLink>
          </div>
          <nav
            className="navbar navbar-nav side-nav pt-0 w-100"
            style={{ paddingRight: "0px" }}
          >
            <ul
              className="navbar-nav w-100 CONTACT-LIST-AREA"
              style={{
                marginLeft: "0px",
                overflowY: "scroll",
                height: "90vh",
              }}
            >
              {permission.find(
                (element) => element.moduleName === "Dashboard"
              ) ? (
                <>
                  <BootstrapTooltip title={"Dashboard"} arrow placement="right">
                    <Link to={"/main/Dashboard"}>
                      <li
                        className={
                          props.sidebarVal == "Dashboard"
                            ? "nav-item sideBaractive"
                            : "nav-item"
                        }
                        id="dashboard_chat_agent"
                        onClick={() => {
                          props.setsidebarVal("Dashboard");
                          props.setShowNotification(false);
                          props.setShowUserProfile(false);
                          props.setshowExternalChat(false);
                          props.setExternalChatData("");
                          props.setExternalChatActive("");
                          props.setshowphonedialer(false);
                          document.title = "Inaipi Digital";
                        }}
                      >
                        <i
                          className="material-symbols-outlined"
                          style={{ color: "#ffff", fontSize: "19px" }}
                        >
                          grid_view
                        </i>
                      </li>
                    </Link>
                  </BootstrapTooltip>
                </>
              ) : null}

              {permission.find((element) => element.moduleName === "Chat") ? (
                <>
                  <BootstrapTooltip
                    title={"Interaction"}
                    arrow
                    placement="right"
                  >
                    <Link to={"/main/Chat"}>
                      <li
                        className={
                          props.sidebarVal == "Chat"
                            ? "nav-item sideBaractive"
                            : "nav-item"
                        }
                        id="chat_chat_agent"
                        onClick={() => {
                          props.setsidebarVal("Chat");
                          props.setShowNotification(false);
                          props.setShowUserProfile(false);
                          props.setshowExternalChat(false);
                          props.setExternalChatData("");
                          props.setExternalChatActive("");
                          document.title = "Inaipi Digital • Chat";
                        }}
                      >
                        <StyledBadge
                          badgeContent={
                            props.notification ? props.notification.length : 0
                          }
                          color="error"
                          invisible={
                            props.notification.length == 0 ? true : false
                          }
                        >
                          <i
                            className="material-symbols-outlined"
                            style={{ color: "#ffff", fontSize: "19px" }}
                          >
                            sms
                          </i>
                        </StyledBadge>
                      </li>
                    </Link>
                  </BootstrapTooltip>
                </>
              ) : null}

              {permission.find((element) => element.moduleName === "Report") ? (
                <BootstrapTooltip
                  title={"Session Report"}
                  arrow
                  placement="right"
                >
                  <Link to={"/main/SessioReports"}>
                    <li
                      className={
                        props.sidebarVal == "Report"
                          ? "nav-item sideBaractive"
                          : "nav-item"
                      }
                      id="sessionreports_chat_agent"
                      onClick={() => {
                        props.setsidebarVal("Report");
                        props.setShowNotification(false);
                        props.setShowUserProfile(false);
                        props.setshowExternalChat(false);
                        props.setExternalChatData("");
                        props.setExternalChatActive("");
                        props.setshowphonedialer(false);
                        document.title = "Inaipi Digital • Reports";
                      }}
                    >
                      <i
                        className="material-symbols-outlined"
                        style={{ color: "#ffff", fontSize: "19px" }}
                      >
                        leaderboard
                      </i>
                    </li>
                  </Link>
                </BootstrapTooltip>
              ) : null}

              {/* CMS */}
              {permission.map((module) => {
                if (module.moduleName === "Crm") {
                  const crmScreen = module.screen.find(
                    (item) =>
                      item.screenId === "CONTACT" && item.read && item.write
                  );

                  if (crmScreen) {
                    return (
                      <BootstrapTooltip title={"CMS"} arrow placement="right">
                        <Link to={"/main/CMS"}>
                          <li
                            className={
                              props.sidebarVal == "CMS"
                                ? "nav-item sideBaractive"
                                : "nav-item"
                            }
                            id="sessionreports_chat_agent"
                            onClick={() => {
                              props.setsidebarVal("CMS");
                              props.setShowNotification(false);
                              props.setShowUserProfile(false);
                              props.setshowExternalChat(false);
                              props.setExternalChatData("");
                              props.setExternalChatActive("");
                              props.setshowphonedialer(false);
                              document.title = "Inaipi Digital • CMS";
                            }}
                          >
                            <i
                              className="material-symbols-outlined"
                              style={{ color: "#ffff", fontSize: "19px" }}
                            >
                              backup_table
                            </i>
                          </li>
                        </Link>
                      </BootstrapTooltip>
                    );
                  } else {
                    return <></>;
                  }
                }
              })}
              {permission.map((module) => {
                if (module.moduleName === "Crm") {
                  const crmScreen = module.screen.find(
                    (item) =>
                      item.screenId === "CONTACTSALES" &&
                      item.read &&
                      item.write
                  );

                  if (crmScreen) {
                    return (
                      <>
                        {" "}
                        <BootstrapTooltip
                          title={"Contact"}
                          arrow
                          placement="right"
                        >
                          <Link to={"/main/Agent-Contact"}>
                            <li
                              className={
                                props.sidebarVal == "AgentContact"
                                  ? "nav-item sideBaractive"
                                  : "nav-item"
                              }
                              id="sessionreports_chat_agent"
                              onClick={() => {
                                props.setsidebarVal("AgentContact");
                                props.setShowNotification(false);
                                props.setShowUserProfile(false);
                                props.setshowExternalChat(false);
                                props.setExternalChatData("");
                                props.setExternalChatActive("");
                                props.setshowphonedialer(false);
                                document.title = "Inaipi Digital • Contact";
                              }}
                            >
                              <i
                                className="material-symbols-outlined"
                                style={{ color: "#ffff", fontSize: "19px" }}
                              >
                                perm_contact_calendar
                              </i>
                            </li>
                          </Link>
                        </BootstrapTooltip>
                      </>
                    );
                  } else {
                    return <></>;
                  }
                }
              })}
              {permission.find(
                (element) => element.moduleName === "Multimedia"
              ) ? (
                <BootstrapTooltip
                  title={"Multimedia Search"}
                  arrow
                  placement="right"
                >
                  <Link to={"/main/multimediasearch"}>
                    <li
                      className={
                        props.sidebarVal == "Multimedia"
                          ? "nav-item sideBaractive"
                          : "nav-item"
                      }
                      id="multimedia_chat_agent"
                      onClick={() => {
                        props.setsidebarVal("Multimedia");
                        document.title = "Inaipi Digital • Multimedia";
                      }}
                    >
                      <i
                        className="fa-solid fa-magnifying-glass"
                        style={{ color: "#ffff", fontSize: "18x" }}
                      ></i>
                    </li>
                  </Link>
                </BootstrapTooltip>
              ) : null}

              {permission.find(
                (element) => element.moduleName === "Calender"
              ) ? (
                <BootstrapTooltip title={"Calender"} arrow placement="right">
                  <Link to={"/main/Calenders"}>
                    <li
                      className={
                        props.sidebarVal == "Calender"
                          ? "nav-item sideBaractive"
                          : "nav-item"
                      }
                      id="Calender_chat_agent"
                      onClick={() => {
                        props.setsidebarVal("Calender");
                        props.setShowNotification(false);
                        props.setShowUserProfile(false);
                        props.setshowExternalChat(false);
                        props.setExternalChatData("");
                        props.setExternalChatActive("");
                        props.setshowphonedialer(false);
                        document.title = "Inaipi Digital • Calender";
                      }}
                    >
                      <i
                        className="material-symbols-outlined"
                        style={{ color: "#ffff", fontSize: "19px" }}
                      >
                        calendar_month
                      </i>
                    </li>
                  </Link>
                </BootstrapTooltip>
              ) : null}

              {permission.find(
                (element) => element.moduleName === "Calender"
              ) ? (
                <BootstrapTooltip
                  title={"Web-Statistic"}
                  arrow
                  placement="right"
                >
                  <Link to={"/main/statistic"}>
                    <li
                      className={
                        props.sidebarVal == "Statistic"
                          ? "nav-item sideBaractive"
                          : "nav-item"
                      }
                      // className="nav-item"
                      id="Calender_chat_agent"
                      onClick={() => {
                        props.setsidebarVal("Statistic");
                        props.setShowNotification(false);
                        props.setShowUserProfile(false);
                        props.setshowExternalChat(false);
                        props.setExternalChatData("");
                        props.setExternalChatActive("");
                        props.setshowphonedialer(false);
                        document.title = "Inaipi Digital • Web Statistic";
                      }}
                    >
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#ffff", fontSize: "19px" }}
                      >
                        pie_chart
                      </span>
                    </li>
                  </Link>
                </BootstrapTooltip>
              ) : null}
              {permission.map((module) => {
                if (module.moduleId === "VOICE") {
                  const crmScreen = module.screen.find(
                    (item) =>
                      item.screenId === "MISSEDCALL" && item.read && item.write
                  );

                  if (crmScreen) {
                    return (
                      <>
                        <BootstrapTooltip
                          title={"Abandoned Calls"}
                          arrow
                          placement="right"
                        >
                          <Link to={"/main/MissedCalls"}>
                            <li
                              className={
                                props.sidebarVal == "Missed Calls"
                                  ? "nav-item sideBaractive"
                                  : "nav-item"
                              }
                              id="reports_chat_supervisor"
                              onClick={() => {
                                props.setsidebarVal("Missed Calls");
                                props.setShowNotification(false);
                                props.setShowUserProfile(false);
                                props.setshowExternalChat(false);
                                props.setExternalChatData("");
                                props.setshowphonedialer(false);
                              }}
                            >
                                          <StyledBadge
                                badgeContent={
                                  AbandonedCount ? AbandonedCount : 0
                                }
                                color="error"
                                invisible={AbandonedCount == 0 ? true : false}
                              >
                                <HiOutlinePhoneMissedCall
                                  size={17}
                                  weight="bold"
                                  color="#ffff"
                                />
                              </StyledBadge>
                            </li>
                          </Link>
                        </BootstrapTooltip>
                      </>
                    );
                  } else {
                    return <></>;
                  }
                }
              })}
              {permission.map((module) => {
                if (module.moduleId === "VOICE") {
                  const crmScreen = module.screen.find(
                    (item) =>
                      item.screenId === "CAMPAIGN" && item.read && item.write
                  );

                  if (crmScreen) {
                    return (
                      <>
                        <BootstrapTooltip
                          title={"Campaign"}
                          arrow
                          placement="right"
                        >
                          <Link to={"/main/Campaign"}>
                            <li
                              className={
                                props.sidebarVal == "Campaign"
                                  ? "nav-item sideBaractive"
                                  : "nav-item"
                              }
                              id="Agent_supervisor"
                              onClick={() => {
                                props.setsidebarVal("Campaign");
                                props.setShowNotification(false);
                                props.setShowUserProfile(false);
                                props.setshowExternalChat(false);
                                props.setExternalChatData("");
                                props.setshowphonedialer(false);
                              }}
                            >
                              <Dresser size={17} weight="bold" color="#ffff" />
                            </li>
                          </Link>
                        </BootstrapTooltip>
                      </>
                    );
                  } else {
                    return <></>;
                  }
                }
              })}
            </ul>
          </nav>
        </aside>
      )}
    </>
  );
};

export default connect(mapStateToProps, {
  clearnotify,
  setsidebarVal,
  setShowNotification,
  setShowUserProfile,
  setshowExternalChat,
  setExternalChatData,
  setExternalChatActive,
  setshowphonedialer,
})(Sidebar);
